import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_CPTS_REQUEST, fetchCptsSuccess, fetchCptsFailure,
  CREATE_CPT_REQUEST, createCptSuccess, createCptFailure,
  UPDATE_CPT_REQUEST, updateCptSuccess, updateCptFailure,
  DELETE_CPT_REQUEST, deleteCptSuccess, deleteCptFailure,
  FETCH_CPT_RULES_REQUEST, fetchCptRulesSuccess, fetchCptRulesFailure,
  MAP_CPT_TO_RULE_REQUEST, mapCptToRuleSuccess, mapCptToRuleFailure,
  DELETE_CPT_RULE_MAPPING_REQUEST, deleteCptRuleMappingSuccess, deleteCptRuleMappingFailure
} from '../actions/cptActions ';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchCpts(action) {
  try {
    const token = getAuthToken();
    const {  page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching cpt with payload: ", action.payload);

    // const response = yield call(axios.get, `${API_BASE_URL}/icd`, createConfig());
    const response = yield call(
      axios.get,
      `${getBaseUrl()}/cpt`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );
    yield put(fetchCptsSuccess(response.data));
  } catch (error) {
    yield put(fetchCptsFailure(error.message));
  }
}

function* createCpt(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/cpt`, action.payload, createConfig());
    yield put(createCptSuccess(response.data));
  } catch (error) {
    yield put(createCptFailure(error.message));
  }
}

function* updateCpt(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/cpt/${id}`, data, createConfig());
    yield put(updateCptSuccess(response.data));
  } catch (error) {
    yield put(updateCptFailure(error.message));
  }
}

function* deleteCpt(action) {
  try {
    yield call(axios.delete, `${API_BASE_URL}/cpt/${action.payload}`, createConfig());
    yield put(deleteCptSuccess(action.payload));
  } catch (error) {
    yield put(deleteCptFailure(error.message));
  }
}

function* fetchCptRules(action) {
  try {
    const { projectId, cptId } = action.payload;
    const response = yield call(axios.get, `${API_BASE_URL}/cpt/${projectId}/${cptId}/rules`, createConfig());
    yield put(fetchCptRulesSuccess(response.data));
  } catch (error) {
    yield put(fetchCptRulesFailure(error.message));
  }
}

function* mapCptToRule(action) {
  try {
    const { projectId, cptId, ruleId } = action.payload;
    yield call(axios.put, `${API_BASE_URL}/cpt/${projectId}/${cptId}/rules/${ruleId}`, {}, createConfig());
    yield put(mapCptToRuleSuccess());
  } catch (error) {
    yield put(mapCptToRuleFailure(error.message));
  }
}

function* deleteCptRuleMapping(action) {
  try {
    const { projectId, cptId, ruleId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/cpt/${projectId}/${cptId}/rules/${ruleId}`, createConfig());
    yield put(deleteCptRuleMappingSuccess());
  } catch (error) {
    yield put(deleteCptRuleMappingFailure(error.message));
  }
}

export default function* cptSaga() {
  yield takeLatest(FETCH_CPTS_REQUEST, fetchCpts);
  yield takeLatest(CREATE_CPT_REQUEST, createCpt);
  yield takeLatest(UPDATE_CPT_REQUEST, updateCpt);
  yield takeLatest(DELETE_CPT_REQUEST, deleteCpt);
  yield takeLatest(FETCH_CPT_RULES_REQUEST, fetchCptRules);
  yield takeLatest(MAP_CPT_TO_RULE_REQUEST, mapCptToRule);
  yield takeLatest(DELETE_CPT_RULE_MAPPING_REQUEST, deleteCptRuleMapping);
}
